import * as React from "react";
import CodeScanner from "../../components/scanner/CodeScanner";
import {CurrentUser} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import {useNavigate} from "react-router";

interface Props {
  currentUser: CurrentUser,
}

function ScannerPage(props: Props) {
  const navigate = useNavigate()

  const successHandler = (result: string) => {
    const codeType = result.split("/")[3];
    const codeId = result.split("/")[4];
    navigate(`/${codeType}/${codeId}`);
  };

  return (
      <>
        <AuthCheck />
        <div className="list-bg">
          <div className={"basic-box"}>
            <div className={"d-inline-block"}><b>Scan Code</b></div>
          </div>
          <CodeScanner successHandler={successHandler}/>
        </div>
      </>
  );
}

export default ScannerPage;